/** Longest note accepted on a cancellation or refund request; the API enforces the same limit. */
export const REQUEST_NOTES_MAX_LENGTH = 1000;
